// extracted by mini-css-extract-plugin
export var actions = "_1h-0";
export var actionsContainer = "_1h-7";
export var border = "_1h-1";
export var childFullHeight = "_1h-f";
export var collapse = "_1h-2";
export var content = "_1h-a";
export var contentChild = "_1h-e";
export var fullscreen = "_1h-c";
export var hasLeftRadius = "_1h-k";
export var headerContainer = "_1h-3";
export var headerRow = "_1h-5";
export var hidePadding = "_1h-b";
export var navCollapsedGap = "_1h-l";
export var noScrollX = "_1h-m";
export var noScrollY = "_1h-n";
export var noTopPadding = "_1h-i";
export var optOutTopPadding = "_1h-d";
export var pageMain = "_1h-j";
export var pageOuter = "_1h-g";
export var pagePadding = "_1h-8";
export var pageScroll = "_1h-9";
export var profile = "_1h-o";
export var profileContainer = "_1h-p";
export var profileImage = "_1h-q";
export var profileMain = "_1h-r";
export var profileSubtitle = "_1h-t";
export var profileTitle = "_1h-s";
export var showLeftPadding = "_1h-h";
export var tabsPortalSlot = "_1h-6";
export var tabsWrapper = "_1h-4";
export var title = "_1h-u";